import React from 'react';
import { typography } from '../../design-system/tokens';

/**
 * Ticket-style summary rows for confirmation modals.
 * @param {{ label: string, value: React.ReactNode, highlight?: boolean }[]} rows
 */
export default function ReceiptSummary({ rows = [], className = '' }) {
  if (!rows.length) return null;

  return (
    <div
      className={`rounded-xl border border-gray-800 bg-black/50 p-4 space-y-3 text-left mb-4 ${className}`}
    >
      {rows.map((row) => (
        <div key={row.label} className="flex justify-between gap-3 items-start">
          <p className={`${typography.microWide} text-gray-600 shrink-0`}>{row.label}</p>
          <p
            className={`text-sm font-black text-right ${
              row.highlight ? 'text-emerald-400' : 'text-white'
            }`}
          >
            {row.value ?? '—'}
          </p>
        </div>
      ))}
    </div>
  );
}
